<app-hero [data]="heroData"></app-hero>

<div class="m-5 p-xl-5 corsi-container text-center" style="background: #ffffff">
  <div class="corsi">
    <div>
      <h2 class="blue-50 bold">Che cosa facciamo?</h2>
      <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
        Proponiamo alle scuole primarie e secondarie corsi di coding, robotica
        educativa, stampa 3D e programmazione app.
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12 col-12 mb-5">
          <div class="container-card-what">
            <h3 class="w-700">
              Sviluppiamo progetti in base alle esigenze delle classi
            </h3>
            <p class="course-desc">
              Prima di iniziare le lezioni organizziamo un incontro con i
              docenti per capire le
              <b>competenze di partenza degli studenti</b>, gli
              <b>strumenti</b> a disposizione e gli <b>argomenti</b> che si
              vogliono affrontare. L’ora di coding non è un momento a sé, ma si
              integra con le altre materie scolastiche, che beneficiano delle
              nostre metodologie didattiche per
              <b>migliorare e consolidare le conoscenze</b> degli alunni.
            </p>
          </div>
        </div>
        <div class="col-lg-6 col-md-12 col-12 mb-5">
          <div class="container-card-what">
            <h3 class="w-700">
              Lavoriamo per lo sviluppo di una scuola innovativa
            </h3>
            <p class="course-desc">
              Un luogo dove il digitale sia vissuto pienamente e con
              <b>consapevolezza</b>. Per noi è importante far conoscere e
              studiare fin dalla primaria i
              <b>linguaggi della programmazione</b>, affinché i bambini imparino
              ad essere creatori (sviluppatori) e non semplici consumatori di
              tecnologia; e diventino, da grandi,
              <b>cittadini attivi della società</b>.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div style="background: rgba(252, 252, 252, 1)">
  <div
    class="m-5 p-xl-5 corsi-container"
    style="background: rgba(252, 252, 252, 1)"
  >
    <div class="obiettivo">
      <div class="ob-col1">
        <div class="obiettivo-title">
          <h2 class="blue-50 bold">Modalità di lezione</h2>
        </div>
        <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
          I nostri corsi in presenza a scuola hanno una durata minima di 12 ore
          per classe o gruppo classe con cadenza settimanale, e possono
          svolgersi sia in orario curriculare - come ampliamento dell’offerta
          formativa - sia in orario extracurricolare.  In più abbiamo sviluppato
          una piattaforma di e-learning che raccoglie videolezioni guidate di
          Scratch, robotica educativa e molto altro. La piattaforma è ad uso
          esclusivo delle scuole, ed è pensata come integrazione e supporto alle
          lezioni in presenza.
        </div>
        <div>
          <button
            class="course-button-link"
            routerLink="/piattaforma-di-apprendimento"
          >
            VAI ALLA PIATTAFORMA
          </button>
        </div>
      </div>
      <div class="ob-col2">
        <img src="../../../assets/img/linkedin.svg" alt="" aria-hidden="true" />
      </div>
    </div>
  </div>
</div>

<div class="m-5 p-xl-5 corsi-container" style="background: #ffffff">
  <div class="obiettivo">
    <div class="ob-col1">
      <div class="obiettivo-title">
        <h2 class="blue-50 bold">Gli insegnanti dei corsi</h2>
      </div>
      <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
        I nostri docenti sono educatori con la passione per il digitale e le
        nuove tecnologie. Hanno l’importante ruolo di insegnare agli studenti le
        basi dell’informatica con uno sguardo principalmente volto
        all’inclusione, al cooperative learning e al problem solving. Gli
        alunni, guidati dai nostri educatori digitali, oltre a creare divertenti
        videogiochi imparano le basi del pensiero computazionale e sviluppano
        competenze di logica e creatività. Se vuoi entrare a far parte del
        nostro team di educatori digitali, inviaci il tuo CV!
      </div>
      <div>
        <button class="course-button-link"  (click)="openModal('E')">INVIA LA CANDIDATURA</button>
      </div>
    </div>
    <div class="ob-col2">
      <img src="../../../assets/img/linkedin-2.svg" alt="" aria-hidden="true" />
    </div>
  </div>
</div>

<div class="bck-citazione-container">
  <div class="citazione-container">
    <div class="desc-start">
      <img src="../../../assets/img/quote_sx.svg" alt="" />
    </div>
    <div class="desc-cit">
      "Learning to write programs stretches your mind, and helps you think
      better, creates a way of thinking about things that I think is helpful in
      all domains."
    </div>
    <div class="desc-end">
      <img src="../../../assets/img/quote_dx.svg" alt="" />
    </div>
  </div>
  <div class="cit-sign">Bill Gates</div>
</div>

<div class="m-5 p-xl-5 corsi-container" style="background: #ffffff">
  <div class="row text-center">
    <h2 class="blue-50 bold mb-3">Obiettivi dei corsi</h2>
  </div>
  <!--desktop view-->
  <div class="row mt-5 d-none d-lg-flex">
    <div class="col-4" *ngFor="let item of obiettiviList">
      <div class="card-school">
        <img src="{{item.img}}" width="58px" alt="" aria-hidden="true" />
        {{item.text}}
      </div>
    </div>
    

  </div>

  <!--fine desktop view-->
  <!--mobile view-->
  <div
  class="row col-12 p-0 m-0 courses-list d-block d-md-block d-lg-none"
  style="gap: 30px; display: inline-flex; background-color: #ffffff; cursor: pointer;"
  #myElement2
>
  <ng-container *ngFor="let course of obiettiviList">
    <div class="col" *ngIf="course.id === obiettiviSelected">
      <div class="card-school">
        <img src="{{course.img}}" width="58px" alt="" aria-hidden="true" />
        {{course.text}}
      </div>
    </div>
  </ng-container>
</div>

<div class="col-1"></div>
<div class="row d-block d-md-block d-lg-none">
  <div class="col pointer-slide">
    <div (click)="changeObiettivi(1)" class="pointer">
      <img
        src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected == 1"
      />
      <img
        src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected != 1"
      />
    </div>
    <div (click)="changeObiettivi(2)" class="pointer">
      <img
        src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected == 2"
      />
      <img
        src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected != 2"
      />
    </div>
    <div (click)="changeObiettivi(3)" class="pointer">
      <img
        src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected == 3"
      />
      <img
        src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected != 3"
      />
    </div>
    <div (click)="changeObiettivi(4)" class="pointer">
      <img
        src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected == 4"
      />
      <img
        src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected != 4"
      />
    </div>
    <div (click)="changeObiettivi(5)" class="pointer">
      <img
        src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected == 5"
      />
      <img
        src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected != 5"
      />
    </div>   <div (click)="changeObiettivi(6)" class="pointer">
      <img
        src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected == 6"
      />
      <img
        src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
        *ngIf="obiettiviSelected != 6"
      />
    </div>
  </div>
</div>
  
</div>

<div class="row m-5 p-xl-5 corsi-container text-center">
  <!--parte card corsi-->
  <div class="corsi">
    <div>
      <h2 class="blue-50 bold">Con i nostri corsi, giocare è imparare</h2>
      <div class="neutral-90 mt-4 mt-xl-3 mb-xl-5 course-desc">
        I nostri percorsi formativi di Easycode per l’educazione digitale
        cominciano qui. Il modo migliore per rendere i ragazzi partecipi
        nell’apprendimento di concetti complessi, è quello di farlo all’interno
        di ambienti divertenti e a loro familiari.
      </div>
    </div>
    <div class="row p-0 m-0">
      <!-- desktop view -->
      <div
        class="row col-12 p-0 m-0 courses-list d-none d-lg-block"
        style="gap: 30px; display: inline-flex; background-color: #ffffff"
      >
        <div class="row g-3">
          <div
            class="mb-4 col-4"
            *ngFor="let course of coursesList"
            style="margin: auto"
          >
            <div class="course-card">
              <img
                [src]="course.img"
                class="course-img"
                alt="Un mondo di corsi per mettersi in gioco"
               
              />

              <div class="course-txt p-3">
                <h3 class="blue-60 w-700 course-ttl">{{ course.name }}</h3>
                <span class="course-desc card-description">{{
                  course.text
                }}</span>
                <button
                  class="course-link mt-5"
                  (click)="openCourse(course)"
                  [attr.aria-label]="'Scopri il corso ' + course.name"
                ><span class="visually-hidden">Scopri il corso {{ course.name }}</span></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- mobile view -->
      <div
        class="row col-12 p-0 m-0 courses-list d-block d-md-block d-lg-none"
        style="gap: 30px; display: inline-flex; background-color: #ffffff; cursor: pointer;"
        #myElement
      >
        <ng-container *ngFor="let course of coursesList">
          <div
            class="mb-4 pointer"
            *ngIf="course.id === slideSelected"
            style="margin: auto"
          >
            <div class="course-card">
              <img
                [src]="course.img"
                class="course-img"
                alt="Un mondo di corsi per mettersi in gioco"
               
              />

              <div class="course-txt p-3">
                <h3 class="blue-60 w-700 course-ttl">{{ course.name }}</h3>
                <span class="course-desc">{{ course.text }}</span>
                <button
                  class="course-link mt-5"
                  (click)="openCourse(course)"
                  [attr.aria-label]="'Scopri il corso ' + course.name"
                ><span class="visually-hidden">Scopri il corso {{ course.name }}</span></button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="col-1"></div>
      <div class="row d-block d-md-block d-lg-none">
        <div class="col pointer-slide">
          <div (click)="changeSlide(1)" class="pointer">
            <img
              src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
              *ngIf="slideSelected == 1"
            />
            <img
              src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
              *ngIf="slideSelected != 1"
            />
          </div>
          <div (click)="changeSlide(2)" class="pointer">
            <img
              src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
              *ngIf="slideSelected == 2"
            />
            <img
              src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
              *ngIf="slideSelected != 2"
            />
          </div>
          <div (click)="changeSlide(3)" class="pointer">
            <img
              src="assets/img/slide-selected.svg" alt="" aria-hidden="true"
              *ngIf="slideSelected == 3"
            />
            <img
              src="assets/img/slide-unselected.svg" alt="" aria-hidden="true"
              *ngIf="slideSelected != 3"
            />
          </div>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center">
      <button class="btn-lightblue my-5" routerLink="/corsi-coding">
        <span class="button-txt">Vai ai corsi</span>
      </button>
    </div>
  </div>
</div>

<!--parte card corsi-->
<div class="m-5 p-xl-5 corsi-container text-center" style="background: #ffffff">
  <div class="card-partner-container">
    <div class="card-container">
      <div class="cardPartner-text">
        <div>
          <h3 class="blue-60">Siamo partner Cdo Opere Educative – FOE</h3>
        </div>
        <div class="course-desc card-d">
          Sei una scuola paritaria associata alla Cdo Opere Educative – FOE?
          Consulta il nostro catalogo corsi e scegli quello più adatto alle tue
          esigenze, avrai uno <b>sconto del 10%</b> sull’acquisto del tuo primo
          corso!
        </div>
        <div class="button-div">
          <div
            class="button-go-courses"
            style="text-align: end"
            routerLink="/corsi-coding"
            role="link"
          >
            VAI AI CORSI <img src="../../../assets/img/Arrow.svg" alt="" aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
    <div class="card-container">
      <div class="cardPartner-text">
        <div>
          <h3 class="blue-60">
            DM 65/2023 Affida a EasyCode la formazione STEM
          </h3>
        </div>
        <div class="course-desc card-d">
          Sei alla ricerca di un <b>partner</b> cui affidare i laboratori per lo
          sviluppo e il potenziamento delle competenze STEM nella tua scuola?
          Contattaci!
        </div>
        <div class="button-div">
          <div
            class="button-go-courses"
            style="text-align: end"
            routerLink="/contatti"
            role="link"
          >
            CONTATTI<img src="../../../assets/img/Arrow.svg" alt="" aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-iscriviti></app-iscriviti>
